// extracted by mini-css-extract-plugin
export default {"wrapper":"z3-z","play":"A3-z"};